/**
 * 실 QR 코드 렌더 — `qrcode` 라이브러리로 canvas에 그린다.
 * value 변경 시 재생성.
 */
import { useEffect, useRef } from "react";
import QRCode from "qrcode";
import { trackError } from "../../telemetry/activity";

interface Props {
  value: string;
  size?: number;
}

export function QRCode2D({ value, size = 320 }: Props) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 0,
      color: { dark: "#111111", light: "#ffffff" },
      errorCorrectionLevel: "M",
    }).catch((err) => {
      console.error("[QRCode2D] render failed", err);
      trackError("qr_render_failed", err);
    });
  }, [value, size]);

  return (
    <canvas
      ref={canvasRef}
      aria-label="QR code"
      style={{
        display: "block",
        width: "100%",
        height: "100%",
        imageRendering: "pixelated",
      }}
    />
  );
}
